module.exports = __webpack_public_path__ + "static/button-mobile-standard-nav-dont-9b109fcee34d8be2b6874497bd0fde94.png";